import React from 'react';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import ConfigDiff from '@/components/Cluster/ConfigDiff';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

/**
 * @param {Object} props
 * @returns
 */
function Summary({ overview, loading }) {
  const items = [
    {
      title: 'Brokers',
      info: <CountUp end={overview.activeBrokerCount} duration={0.4} />,
      unit: overview.pulsarVersion,
      icon: 'other2',
    },
    {
      title: 'Bundles',
      info: <CountUp end={overview.totalBundles} duration={0.4} />,
      tip: '分配的Bundle个数（可进行负载均衡最小粒度）',
      icon: 'other3',
    },
    {
      title: '连接数',
      info: <CountUp end={overview.totalConnects} duration={0.4} />,
      icon: 'other4',
      tip: '建立TCP连接个数',
    },
    <ConfigDiff
      key={1}
      title='Similar Config'
      icon='other5'
      correct={overview.similarConfig}
      data={overview.similarConfigVOList || []}
    />,
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect((state) => ({
  overview: state.broker.overview,
  loading: state.broker.loading,
}))(Summary);
